import config from "@Config/index";
import { updateUserHistoryData } from "@App/userHistoryReducer";
import axios from "axios";
import { Dispatch } from "react";

const fetchUserHistory = async (dispatch: Dispatch<any>) => {
  try {
    const response = await axios.get(`${config.API_URL}/api/v0/user_flow/history`, {
      params: {
        methods: "redirection_urls",
      },
      withCredentials: true,
    });

    if (response.data && response.data.message === "success") {
      dispatch(updateUserHistoryData(response.data.data));
      return response?.data?.data;
    }
  } catch (error) {
    console.log("Error", error);
    return null;
  }
  return null;
};

export default fetchUserHistory;
